// Custom filter method for range filtering
const rangeFilterMethod = (filter, row) => {
    const { value } = filter;
    if (!value) return true;

    const cellValue = row[filter.id];
    if (cellValue === null || cellValue === undefined) return false;

    const numericValue = parseFloat(cellValue);
    if (isNaN(numericValue)) return false;

    // Parse range (e.g., "10-20", "10-", "-20", "10")
    const rangeParts = value.split('-');
    
    if (rangeParts.length === 1) {
        // Single value (exact match)
        return numericValue === parseFloat(rangeParts[0]);
    } else if (rangeParts.length === 2) {
        const minValue = rangeParts[0] === "" ? Number.NEGATIVE_INFINITY : parseFloat(rangeParts[0]);
        const maxValue = rangeParts[1] === "" ? Number.POSITIVE_INFINITY : parseFloat(rangeParts[1]);
        
        return numericValue >= minValue && numericValue <= maxValue;
    }
    
    return true;
};

export default rangeFilterMethod;
